import React from 'react';
import FacilitiesSelector from './FacilitiesSelector';
import { useLanguage } from '../../i18n/LanguageContext';
import './ObjectForm.css';

const PropertyFields = ({ 
  propertyType, 
  facilities, 
  setFacilities,
  floor, 
  setFloor,
  monthlyFee, 
  setMonthlyFee,
  balconyType, 
  setBalconyType,
  plotSize, 
  setPlotSize,
  constructionYear, 
  setConstructionYear,
  numberOfFloors, 
  setNumberOfFloors,
  heatingSystem, 
  setHeatingSystem,
  validationErrors,
  ValidationErrorMessage
}) => {
  const { t } = useLanguage();

  if (propertyType === 'Lägenhet') {
    return (
      <div className="property-specific-fields">
        <h3>{t('objectForm.apartmentDetails')}</h3>
        
        <label htmlFor="floor">{t('objectForm.floor')}:</label>
        <input
          type="number"
          id="floor"
          value={floor}
          onChange={(e) => setFloor(e.target.value)}
          placeholder="0 - 50"
          className={validationErrors?.floor ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="floor" />}
                
        <label htmlFor="monthlyFee">{t('objectForm.monthlyFee')}:</label>
        <input
          type="number"
          id="monthlyFee"
          value={monthlyFee}
          onChange={(e) => setMonthlyFee(e.target.value)}
          placeholder="0 - 100000"
          className={validationErrors?.monthlyFee ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="monthlyFee" />}
        
        <label htmlFor="balconyType">{t('objectForm.balcony')}:</label>
        <select
          id="balconyType"
          value={balconyType}
          onChange={(e) => setBalconyType(e.target.value)}
        >
          <option value="">{t('common.select')}</option>
          <option value="Ingen">{t('objectForm.none')}</option>
          <option value="Balkong">{t('Balkong')}</option>
          <option value="Fransk balkong">{t('objectForm.frenchBalcony')}</option>
          <option value="Uteplats">{t('Uteplats')}</option>
          <option value="Balkong och uteplats">{t('objectForm.balconyAndPatio')}</option>
        </select>
        
        <FacilitiesSelector 
          propertyType={propertyType}
          selectedFacilities={facilities}
          onChange={setFacilities}
        />
      </div>
    );
  } else if (propertyType === 'Villa' || propertyType === 'Radhus') {
    return (
      <div className="property-specific-fields">
        <h3>{t('objectForm.houseDetails')}</h3>
        
        <label htmlFor="plotSize">{t('objectForm.plotSize')}:</label>
        <input
          type="number"
          id="plotSize"
          value={plotSize}
          onChange={(e) => setPlotSize(e.target.value)}
          placeholder="1 - 1000000"
          className={validationErrors?.plotSize ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="plotSize" />}
        
        <label htmlFor="constructionYear">{t('objectForm.constructionYear')}:</label>
        <input
          type="number"
          id="constructionYear"
          value={constructionYear}
          onChange={(e) => setConstructionYear(e.target.value)}
          placeholder="1800 - 2030"
          className={validationErrors?.constructionYear ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="constructionYear" />}
        
        <label htmlFor="numberOfFloors">{t('objectForm.floors')}:</label>
        <select
          id="numberOfFloors"
          value={numberOfFloors}
          onChange={(e) => setNumberOfFloors(e.target.value)}
        >
          <option value="1">1</option>
          <option value="1.5">1.5</option>
          <option value="2">2</option>
          <option value="2.5">2.5</option>
          <option value="3">{t('objectForm.threeOrMore')}</option>
        </select>
        
        <label htmlFor="heatingSystem">{t('objectForm.heatingSystem')}:</label>
        <select
          id="heatingSystem"
          value={heatingSystem}
          onChange={(e) => setHeatingSystem(e.target.value)}
        >
          <option value="">{t('common.select')}</option>
          <option value="Fjärrvärme">{t('objectForm.districtHeating')}</option>
          <option value="Värmepump">{t('objectForm.heatPump')}</option>
          <option value="Direktverkande el">{t('objectForm.directElectricity')}</option>
          <option value="Pellets">{t('Pellets')}</option>
          <option value="Olja">{t('objectForm.oil')}</option>
          <option value="Annat">{t('objectForm.other')}</option>
        </select>
        
        <FacilitiesSelector 
          propertyType={propertyType}
          selectedFacilities={facilities}
          onChange={setFacilities}
        />
      </div>
    );
  } else if (propertyType === 'Fritidsboende') {
    return (
      <div className="property-specific-fields">
        <h3>{t('objectForm.vacationDetails')}</h3>
        
        <label htmlFor="plotSize">{t('objectForm.plotSize')}:</label>
        <input
          type="number"
          id="plotSize"
          value={plotSize}
          onChange={(e) => setPlotSize(e.target.value)}
          placeholder="1 - 1000000"
          className={validationErrors?.plotSize ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="plotSize" />}
        
        <label htmlFor="constructionYear">{t('objectForm.constructionYear')}:</label>
        <input
          type="number"
          id="constructionYear"
          value={constructionYear}
          onChange={(e) => setConstructionYear(e.target.value)}
          placeholder="1800 - 2030"
          className={validationErrors?.constructionYear ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="constructionYear" />}
        
        <label htmlFor="numberOfFloors">{t('objectForm.floors')}:</label>
        <select
          id="numberOfFloors"
          value={numberOfFloors}
          onChange={(e) => setNumberOfFloors(e.target.value)}
        >
          <option value="1">1</option>
          <option value="1.5">1.5</option>
          <option value="2">2</option>
          <option value="2.5">2.5</option>
        </select>
        
        <label htmlFor="heatingSystem">{t('objectForm.heatingSystem')}:</label>
        <select
          id="heatingSystem"
          value={heatingSystem}
          onChange={(e) => setHeatingSystem(e.target.value)}
        >
          <option value="">{t('common.select')}</option>
          <option value="Direktverkande el">{t('objectForm.directElectricity')}</option>
          <option value="Värmepump">{t('objectForm.heatPump')}</option>
          <option value="Vedkamin">{t('objectForm.woodStove')}</option>
          <option value="Kombination">{t('objectForm.combination')}</option>
          <option value="Annat">{t('objectForm.other')}</option>
        </select>
        
        <FacilitiesSelector 
          propertyType={propertyType}
          selectedFacilities={facilities}
          onChange={setFacilities}
        />
      </div>
    );
  } else if (propertyType === 'Tomt') {
    return (
      <div className="property-specific-fields">
        <h3>{t('objectForm.plotDetails')}</h3>
        
        <label htmlFor="plotSize">{t('objectForm.plotSize')}:</label>
        <input
          type="number"
          id="plotSize"
          value={plotSize}
          onChange={(e) => setPlotSize(e.target.value)}
          placeholder="1 - 1000000"
          className={validationErrors?.plotSize ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="plotSize" />}
        
        <FacilitiesSelector 
          propertyType={propertyType}
          selectedFacilities={facilities}
          onChange={setFacilities}
        />
      </div>
    );
  } else if (propertyType === 'Gård/skog') {
    return (
      <div className="property-specific-fields">
        <h3>{t('objectForm.farmDetails')}</h3>
        
        <label htmlFor="plotSize">{t('objectForm.areaSize')}:</label>
        <input
          type="number"
          id="plotSize"
          value={plotSize}
          onChange={(e) => setPlotSize(e.target.value)}
          placeholder="1 - 1000000"
          className={validationErrors?.plotSize ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="plotSize" />}
        
        <label htmlFor="constructionYear">{t('objectForm.constructionYearIfAny')}:</label>
        <input
          type="number"
          id="constructionYear"
          value={constructionYear}
          onChange={(e) => setConstructionYear(e.target.value)}
          placeholder="1800 - 2030"
          className={validationErrors?.constructionYear ? 'input-error' : ''}
        />
        {ValidationErrorMessage && <ValidationErrorMessage fieldName="constructionYear" />}
        
        <FacilitiesSelector 
          propertyType={propertyType}
          selectedFacilities={facilities}
          onChange={setFacilities}
        />
      </div>
    );
  } else if (propertyType === 'Övrigt') {
    return (
      <div className="property-specific-fields">
        <h3>{t('objectForm.otherDetails')}</h3>
        
        <FacilitiesSelector 
          propertyType={propertyType}
          selectedFacilities={facilities}
          onChange={setFacilities}
        />
      </div>
    );
  }
  
  return null;
};

export default PropertyFields; 
